import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog/index';
import DialogActions from '@material-ui/core/DialogActions/index';
import DialogContent from '@material-ui/core/DialogContent/index';
import Grid from "@material-ui/core/Grid";
import DraggableModal from "../../../Include/DraggableModal/DraggableModal";
import {FieldsJs} from "../../../../settings/General/General";
import Slide from "@material-ui/core/Slide";
import {
	BotonActualizarLista,
	BotonExportarListaExcel,
	BotonExportarListaPDF,
	CabeceraTituloPdfExcelLista
} from "../../../Include/MiniComponents/GlobalComponent";
import Button from "@material-ui/core/Button";
import Zoom from "@material-ui/core/Zoom";
import IconButton from "@material-ui/core/IconButton";
import {HomeWorkOutlined} from "@material-ui/icons";
import Tooltip from "@material-ui/core/Tooltip";
import BancoSucursalService from "../../../../services/_Cat/BancoSucursalService/BancoSucursalService";
import {ReactLocalStorageService} from "../../../../settings/ReactLocalStorageService/ReactLocalStorageService";
import ListaTabla from "./Includes/ListaTabla";
import VistaVacia from "../../../Include/VistaVacia/VistaVacia";
import ModalBancoSucursal from "./Includes/ModalBancoSucursal";

class BancoSucursal extends Component {
	
	state = {};
	
	Usr = {};
	
	constructor(props) {
		super(props);
		this.Usr = ReactLocalStorageService.get('Usr') || {};
		this.state = {
			modal: {
				open: false
			},
			id_cat_banco: (props.item || {}).id_cat_banco,
			cat_banco_sucursal: [],
		};
	}
	
	closeModal = () => {
		this.setState({
			modal: {
				open: false
			}
		});
	};
	
	close = () => {
		this.closeModal();
	};
	
	openModal = () => {
		const props = this.props;
		this.setState({
			modal: {
				open: true
			}
		});
	};
	
	open = () => {
		this.init().then(r => {
			setTimeout(() => this.openModal());
		}).catch(e => {
		});
	};
	
	RefreshList = () => {
		this.init();
	};
	
	init = () => {
		return new Promise((resolve, reject) => {
			BancoSucursalService.Listar(this.state.id_cat_banco).then((response) => {
				
				this.setState({cat_banco_sucursal: response.data});
				
				resolve(true);
				
			}).catch((error) => {
				
				this.setState({cat_banco_sucursal: []});
				
				this.props.showSnackBars('error', error.mensaje);
				
				reject(false);
				
			});
		});
	};
	
	render() {
		
		return (
			<div>
				
				<Tooltip TransitionComponent={Zoom} placement={"top"} title="Sucursales">
					<IconButton aria-label="Sucursales" onClick={() => this.open()}>
						<HomeWorkOutlined/>
					</IconButton>
				</Tooltip>
				
				<Dialog open={this.state.modal.open} onClose={() => this.close()} PaperComponent={DraggableModal}
				        disableEscapeKeyDown disableBackdropClick maxWidth={'lg'} fullWidth={true} scroll={'paper'}
				        transition={<Slide direction="up"/>} aria-labelledby="scroll-dialog-title"
				>
					
					<DialogContent>
						
						<Grid container spacing={1}>
							
							<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
								
								<CabeceraTituloPdfExcelLista
									titulo={'Sucursales'}
									botonPDF={
										<Fragment>
											{FieldsJs.inArray([1, 2], this.Usr.id_cat_tipo_usuario) ? (
												<BotonExportarListaPDF onClick={() => {
												
												}}/>
											) : ''}
										</Fragment>
									}
									botonEXCEL={
										<Fragment>
											{FieldsJs.inArray([1, 2], this.Usr.id_cat_tipo_usuario) ? (
												<BotonExportarListaExcel onClick={() => {
												
												}}/>
											) : ''}
										</Fragment>
									}
									botonLISTA={
										<Fragment>
											<BotonActualizarLista onClick={() => {
												this.RefreshList();
											}}/>
										</Fragment>
									}
									marginTop={10}
									marginBottom={10}
								/>
							
							</Grid>
							
							<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
								
								<div className={'form margin-30-B'}>
									
									{this.state.cat_banco_sucursal.length > 0 ? (
										<ListaTabla
											lista={this.state.cat_banco_sucursal}
											RefreshList={this.RefreshList}
											showSnackBars={this.props.showSnackBars}
										/>
									) : (
										<VistaVacia
											width={70}
											height={70}
											numero={0}
											mensaje={'No se encontraron datos.'}
										/>
									)}
								
								</div>
								
								<ModalBancoSucursal
									tipo={'add'}
									item={{
										id_cat_banco_sucursal: null,
										id_cat_banco: this.state.id_cat_banco
									}}
									RefreshList={this.RefreshList}
									showSnackBars={this.props.showSnackBars}
								/>
							
							</Grid>
						
						</Grid>
					
					</DialogContent>
					
					<DialogActions>
						<Grid container spacing={1}>
							<Grid item xs={6} sm={6} md={6} lg={6} xl={6} align={'left'}>
								<Button onClick={this.close} color="primary">
									Cerrar
								</Button>
							</Grid>
							<Grid item xs={6} sm={6} md={6} lg={6} xl={6} align={'right'}>
							</Grid>
						</Grid>
					</DialogActions>
				
				</Dialog>
			
			</div>
		);
	}
}

BancoSucursal.propTypes = {
	item: PropTypes.object.isRequired,
	RefreshList: PropTypes.func.isRequired,
	showSnackBars: PropTypes.func.isRequired,
};

export default BancoSucursal;
